export default __webpack_public_path__ + "static/typography-styles-b889dbaf6f13264e69cfaf26022e5768.png";